import {
    CONTEXT_SET_COUNTRY, CONTEXT_SET_CONTEXT, CONTEXT_SET_CUSTOMER, CONTEXT_SET_CUSTOMERTYPE, SETTING_SET_PERIMETER_FILTER,
    SETTING_SET_VEH_DESC_TYPE, SETTING_SET_DEVELOPPER_VIEW,
    VEHICLE_SET_VEHICLE, PARAMETERS_SET_PARAMETERS, VEHICLES_SET_VEHICLES_CONFIG, VEHICLES_SET_VEHICLES_STOCK, PARAMETERS_SET_WIDPARAMETERS,
    SET_PART_EXCHANGE, WIDGET_OPEN, SETTING_SET_WIDGET_TYPE, RELOAD_WIDGET_SFS
} from '../actions/actionsAppTest';

import HelperEnv from '../helpers/HelperEnv';

export const initialStateWidget = { isPayloadToProvide: true };

export function widget(state, action) {
    switch (action.type) {
        case CONTEXT_SET_COUNTRY:
        case CONTEXT_SET_CONTEXT:
        case CONTEXT_SET_CUSTOMER:
        case CONTEXT_SET_CUSTOMERTYPE:
        case SETTING_SET_PERIMETER_FILTER:
        case SETTING_SET_VEH_DESC_TYPE:
        case VEHICLE_SET_VEHICLE:
        case PARAMETERS_SET_PARAMETERS:
        case VEHICLES_SET_VEHICLES_CONFIG:
        case VEHICLES_SET_VEHICLES_STOCK:
        case PARAMETERS_SET_WIDPARAMETERS:
        case SET_PART_EXCHANGE:
        case SETTING_SET_WIDGET_TYPE:
        case SETTING_SET_DEVELOPPER_VIEW:
        case RELOAD_WIDGET_SFS:
            return { ...state, isPayloadToProvide: true };
        case WIDGET_OPEN:
            if (state.widgetBpfVersion == null) {
                const widgetVersion = HelperEnv.retrieveWidgetBPFVersion();
                state = { ...state, widgetBpfVersion: widgetVersion }
            }
            return { ...state, isPayloadToProvide: false };

        default:
            return state;
    }
}
